import { useForm } from '@tanstack/react-form'
import { getRouteApi, useNavigate } from '@tanstack/react-router'
import { Toast, handleFormSubmissionError } from 'ui/components'
import { useCreateDocument } from '~bank-documents/service/saveDocument'
import { ManageDocumentFormType } from '~bank-documents/types/documentEdit'

import { bankDocumentMessages as m } from '../../messages/bankDocumentMessages'
import { mapManageDocumentRequest } from '../../utils/mapManageDocumentRequest'
import { ManageDocumentPage } from '../commonPages/ManageDocumentPage'

const routeApi = getRouteApi('/_app/documents/new')

const CreateDocument = () => {
  const navigate = useNavigate()
  const { subjectType, bankAccountId, companyId, contactId, licenseId, returnUrl } = routeApi.useSearch()

  const form = useForm({
    defaultValues: new ManageDocumentFormType(true, undefined, {
      type: subjectType,
      id: bankAccountId || companyId || contactId || licenseId
    }),
    onSubmit: async ({ value }) => await createDocument(mapManageDocumentRequest(value))
  })

  const { routine: createDocument } = useCreateDocument({
    onSuccess: async (_, response) => {
      if (returnUrl) {
        await navigate({ to: returnUrl as never })
      } else if (response.id) {
        await navigate({ to: '/documents/$documentId', params: { documentId: response.id.toString() } })
      }
      Toast.successSmall('Document was created.')
    },
    onError: (error) => {
      handleFormSubmissionError<ManageDocumentFormType>(error, form)
    }
  })

  return (
    <ManageDocumentPage
      isNew={true}
      form={form}
      pageSubtitle={m['bankDocuments.createForm.pageTitle']}
      panelTitle={m['bankDocuments.createForm.title']}
    />
  )
}

export default CreateDocument
